import React from 'react';
import { connect } from 'react-redux';
import { fetchLedmodules, resetLedmodules, deleteLedmodule } from '../../../actions';
import LedmoduleListItem from './LedmoduleListItem';
import { Table, Row, Modal, Button } from 'react-bootstrap';
import LedmodulePlaceholder from './LedmodulePlaceholder';

class LedmodulesCloudList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			deletingLoader: false,
			ledmoduleToDelete: null,
		};

		this.askToDeleteLedmodule = this.askToDeleteLedmodule.bind(this);
		this.deleteLedmodule = this.deleteLedmodule.bind(this);
	}

	componentDidMount() {
		this.props.fetchLedmodules();
	}

	renderList() {
		//Sorting Ledmodules by creationDate
		// this.props.ledmodules.sort((a, b) => (b.creationDate > a.creationDate) ? 1 : ((a.creationDate > b.creationDate) ? -1 : 0));
		this.props.ledmodules.sort((a, b) => a.order - b.order);

		return this.props.ledmodules.map(ledmodule => {
			return (
				<LedmoduleListItem key={ledmodule.id} ledmodule={ledmodule} deleteLedmodule={this.askToDeleteLedmodule} />
			);
		});
	}

	askToDeleteLedmodule(ledmodule) {
		this.setState({ ledmoduleToDelete: ledmodule });
	}

	deleteLedmodule() {
		//starting loader
		this.setState({ deletingLoader: true });

		this.props.deleteLedmodule(this.state.ledmoduleToDelete.id)
			.then(() => {
				this.props.fetchLedmodules()
					.then(() => {
						//stop loader
						this.setState({ ledmoduleToDelete: null, deletingLoader: false });
					});
			});
	}

	componentWillUnmount() {
		this.props.resetLedmodules();
	}

	render() {

		if (!this.props.ledmodules || this.state.deletingLoader) {
			return (<LedmodulePlaceholder />);
		}

		return (
			<div className="container-ledmodule-cloud-list">
				<Row className="header-ledmodule-cloud-list" style={{ height: "5vh" }}>
					<b>Ledmodules</b>
				</Row>

				<Table responsive striped bordered hover size="sm">
					<thead>
						<tr>
							<th>Ledmodule Name</th>
							<th>Description</th>
							<th>Last Modified</th>
							<th>Published</th>
							<th style={{ width: '1.5em' }}></th>
						</tr>
					</thead>
					<tbody className="tbody-ledmodule-cloud-list">
						{this.renderList()}
					</tbody>
				</Table>

				<Modal show={this.state.ledmoduleToDelete !== null} onHide={() => this.setState({ ledmoduleToDelete: null })} animation={false}>
					<Modal.Header closeButton>
						<Modal.Title style={{ color: "#E95B0D" }}>Warning</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<p> Are you sure that you want to delete <i>{this.state.ledmoduleToDelete ? this.state.ledmoduleToDelete.name : 'the ledmodule'}</i> ? </p>
					</Modal.Body>

					<Modal.Footer>
						<Button variant="primary" style={{ marginRight: "0" }} onClick={this.deleteLedmodule}>Yes</Button>
						<Button variant="secondary" onClick={() => this.setState({ ledmoduleToDelete: null })}>No</Button>
					</Modal.Footer>
				</Modal>
				{/* <div className="overflow-y ui celled list segment">{this.renderList()}</div> */}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		ledmodules: state.ledmodules != null ? Object.values(state.ledmodules) : null,
	};
};

const mapDispatchToProps = {
	fetchLedmodules,
	resetLedmodules,
	deleteLedmodule
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LedmodulesCloudList);
